import { render, staticRenderFns } from "./viewServiceInfo.vue?vue&type=template&id=f5dc7e94"
import script from "./viewServiceInfo.vue?vue&type=script&lang=js"
export * from "./viewServiceInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports